<div class="content-camps">
    <msc-timeline [context]="'camp'" [contextId]="campId" [manage]="true"></msc-timeline>
</div>
